import { SizeType, Theme } from "@remo-co/ui-core/src/types";
import { makeStyles } from "@remo-co/ui-core/src/utils/makeStyles";

interface BottomBarProps {
  opened: boolean;
  breakpoint: SizeType;
}

export const useStyles = makeStyles<Theme, BottomBarProps>((theme) => ({
  desktopContainer: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    alignItems: "center",
  },
  mobileContainer: ({ opened, breakpoint }) => ({
    "& > *:last-child": {
      marginRight: "auto",
    },
    "& > *:first-child": {
      marginLeft: "auto",
    },
    padding: opened ? `${theme.spacing(0.75)} 0` : "0",
    boxSizing: "border-box",
    height: "100%",
    alignItems: "center",
    maxHeight: opened ? "128px" : "0",
    transition: "max-height 0.2s",
    overflow: "auto hidden",
    display: "flex",
    width: "100vw",
    "&::-webkit-scrollbar": {
      height: 5,
    },
    [theme.breakpoints.up(breakpoint)]: {
      height: 0,
    },
  }),
  childrenContainer: {
    height: "100%",
    padding: `${theme.spacing(0.75)} 0`,
    backgroundColor: theme.palette.background.default,
    alignItems: "center",
    justifyContent: "center",
    display: "flex",
    width: "100%",
  },
}));
